import jstz from 'jstz';

export const FALLBACK_TIMEZONE = 'UTC';

export function getBrowserTimezone() {
    // Using jsTimezoneDetect instead of Moment.js to determine the timezone
    // because of this bug: https://github.com/moment/moment-timezone/issues/559
    const timezone = jstz.determine().name();

    return timezone || FALLBACK_TIMEZONE;
}
